import { useMutation, useQueryClient } from 'react-query'
import ApiClient from '../lib/api-client'

function useSaveConfig () {
  const queryClient = useQueryClient()
  return useMutation(
    (record) => ApiClient
      .patch('/community/config-update', record)
      .then(data => data),
    {
      onSuccess: (record, error) => {
        queryClient.invalidateQueries(['tenant', 'configs'])
      }
    }
  )
}

export default useSaveConfig
